import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import { MultipleViewTypeListActiveItemPreviewHeaderActions } from '../../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../../PageEmptyState'
import Text from '../../../../Text'
import { QA_NAME_LISTING_PROFILE_PREVIEW_RETRY } from '../RentalPortalListingProfile.constants'

import * as styles from './RentalPortalListingProfilePreviewError.module.css'

import RefreshIcon from '../../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../../icons/rental-portal.svg'

function RentalPortalListingProfilePreviewError({
  openFullPageActionsProps,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={RentalPortalIcon}
      className={styles.RentalPortalListingProfilePreviewError}
    >
      <Text isSecondary>
        {t('RentalPortal.ListingProfilePreviewLoadErrorKey')}
      </Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        qaName={QA_NAME_LISTING_PROFILE_PREVIEW_RETRY}
        text={t('RentalPortal.ListingRetryBtnKey')}
        onClick={onRetry}
      />
      {openFullPageActionsProps ? (
        <MultipleViewTypeListActiveItemPreviewHeaderActions
          {...openFullPageActionsProps}
        />
      ) : null}
    </PageEmptyState>
  )
}

export default RentalPortalListingProfilePreviewError
